module.exports = __webpack_public_path__ + "static/media/rom19.05506c34.jpg";